import { Box } from '@user-portal/wikr-components';
import { QRCodeSVG } from 'qrcode.react';

import Skeleton from 'components/Skeleton';

import * as S from './styled';

import { IScanQrCodeProps } from './types';

const ScanQrCode = ({
    isLoading,
    deepLinkUrl,
    sizeQRCode = 160,
    sizeSkeleton = 200,
    mb = 0,
    dataLocator,
}: IScanQrCodeProps) => {
    return (
        <S.ScanQrCodeWrapper $mb={mb} dataLocator={dataLocator}>
            {isLoading ? (
                <Skeleton borderRadius={16} width={sizeSkeleton} height={sizeSkeleton} />
            ) : (
                <Box
                    $paddingX={20}
                    $paddingTop={20}
                    $paddingBottom={20}
                    $backgroundColor="surface-default"
                    $borderRadius={16}
                >
                    <QRCodeSVG data-locator="deeplinkQRCode" size={sizeQRCode} value={deepLinkUrl} />
                </Box>
            )}
        </S.ScanQrCodeWrapper>
    );
};

export default ScanQrCode;
